<div class="delivery-notes-grid-container">
  @if (hasDeliveryNotes()) {
    <div class="ag-grid-wrapper">
      <dw-grid-ag-grid
        #agGrid
        [inputRowData]="deliveryNotes() ?? []"
        [columnDefs]="columnDefs"
        [gridOptions]="gridOptions"
        [hasPagination]="false"
        [hideFilter]="true"
        [hidePanelColumn]="true"
        [autoSize]="false"
        (gridReady)="onGridReady()"
      >
      </dw-grid-ag-grid>
    </div>
  } @else if (hasNoDeliveryNotes()) {
    <div class="no-data-message">
      <div class="text-center text-muted py-4">
        <i class="fa fa-info-circle fa-2x mb-2"></i>
        <p>{{ 'Doc::CustomerPreparation:NoDeliveryNotesToPrepare' | abpLocalization }}</p>
      </div>
    </div>
  }
</div>
